import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ForgotPasswordInterface,
  LoginInterface,
  ResetPasswordInterface,
  UserInterface,
} from '../models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private BASE_URL = environment.BASE_URL;

  currentUser = signal<UserInterface | undefined | null>(undefined);
  userId = signal<string | null>(null);

  login$(payload: LoginInterface): Observable<any> {
    const url = `${this.BASE_URL}/login`;
    return this.http.post(url, payload);
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    this.currentUser.set(null);
    this.router.navigateByUrl('/auth');
  }

  getProfile$(userId: string): Observable<UserInterface> {
    const url = `${this.BASE_URL}/user/profile/${userId}`;
    return this.http.get<UserInterface>(url);
  }

  //TODO: will do this later
  forgotPassword$(email: ForgotPasswordInterface): Observable<any> {
    const url = `${this.BASE_URL}/forgotPass`;
    return this.http.post<ForgotPasswordInterface>(url, email);
  }

  resetPassword$(payload: ResetPasswordInterface): Observable<any> {
    const url = `${this.BASE_URL}/forgotPassSet`;
    return this.http.post<ResetPasswordInterface>(url, payload);
  }
}
